import React from "react";
import qs from "query-string";
import PropTypes from "prop-types";
//import moment from 'moment';

import {
  arrangeData,
  encodeJsonString,
} from "components/list/action/action-util";
//import Link from 'next/link';
import View from "components/list/view/View";
import { autobind } from "react-decoration";
import rr from "lib/ResourceRelated";
import ListCateComp from "components/resource/ListCateComp";
import ReactHtmlParser from "react-html-parser";
import { navigate } from "gatsby";
import Link from "lib/Link";

class DBDisplayComp extends View {
  constructor(props) {
    super(props);
  }

  @autobind
  toResource(resource, e) {
    e.preventDefault();
    let { search } = this.props;
    let params = { ...search };
    let filterField = params.filterField || [];
    let filterValue = params.filterValue || [];
    filterField.push("source");
    filterValue.push(resource);
    params.filterField = filterField;
    params.filterValue = filterValue;
    navigate(["/resourceList", qs.stringify(params)].join("?"));
  }

  render() {
    let {
      displayConfig,
      data,
      resourceData,
      functionConfigList,
      functionRightConfigList,
      buttonEvent,
      batchConfig,
      rowStyle,
      serialNo,
      auth,
      handleClick,
      displayCheckBox,
      i18n,
      t,
      info,
      refetch,
    } = this.props;

    const arrangedData = arrangeData(data);

    const { id, ebname, en_ebname, url, intro } = arrangedData;

    let { language } = i18n;

    let maxIntroLen = 50;
    let urlData = resourceData.dbURLList;
    let attachData = resourceData.dbAttachList;
    let {
      userCollectionList,
      journalCollect = "",
      ermEJournal = "",
      ermProcLink = "",
    } = info || [];
    let recommendResource = resourceData.recommendResource;
    let newResource = resourceData.newResource;
    let trialResource = resourceData.trialResource;
    let joCount = resourceData.joCount || 0;
    let pJoCount = resourceData.pJoCount || 0;
    let ebookCount = resourceData.ebookCount || 0;
    let imagesPath = language === "en" ? "/images_hyint_eng/" : "/images_hyint/";
    return (
      <>
        <div className={`list_block ${rowStyle}`}>
          <div className="list_num">{serialNo}</div>
          <ListCateComp
            {...this.props}
            id={id}
            userCollectionList={userCollectionList}
            resourceType={"databases"}
            refetch={refetch}
          />
          <div className="list_data">
            <h3>
              <a
                tabIndex="0"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick({ id });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleClick({ id });
                  }
                }}>
                {(() => {
                  if (language === "zh") {
                    return ebname;
                  } else if (language === "en" && en_ebname !== undefined) {
                    return en_ebname;
                  } else {
                    return ebname;
                  }
                })()}
              </a>
            </h3>
            {recommendResource && (
              <button
                type="button"
                tabIndex="0"
                className="btn_primary recommend"
                onClick={this.toResource.bind(this, "core")}>
                {t("jumper.common.limiter.core")}
              </button>
            )}
            {newResource && (
              <button
                type="button"
                tabIndex="0"
                className="btn_primary new"
                onClick={this.toResource.bind(this, "news")}>
                {t("jumper.common.limiter.news")}
              </button>
            )}
            {trialResource && (
              <button
                type="button"
                tabIndex="0"
                className="btn_primary test"
                onClick={this.toResource.bind(this, "4")}>
                {t("jumper.common.limiter.trial")}
              </button>
            )}
            <ul>
              {data.map((item, keys) => {
                let outTemp = [];
                if (item.key === "journal_url") {
                  let journalURLTemp = [];
                  if (
                    (
                      journalCollect === "" ||
                      journalCollect === "0" ||
                      journalCollect === "1"
                    ) &&
                    item.value !== ""
                  ) {
                    journalURLTemp.push(
                      <li>
                        <div className="title">
                          {t("jumperrwd.eb_basic_extension.name." + item.key)}:
                        </div>
                        <Link href={item.value} target="_blank">
                          ({this.props.t("jumper.common.listview")})
                        </Link>
                      </li>
                    );
                  }
                  if (
                    journalCollect === "" ||
                    journalCollect === "0" ||
                    journalCollect === "2"
                  ) {
                    if (ermEJournal === "1") {
                      if (ermProcLink === "") {
                        if (joCount !== 0) {
                          journalURLTemp.push(
                            <li>
                              <div className="title">
                                {this.props.t("hyint.esource.collectjournal")}:
                              </div>
                              <Link
                                href={
                                  "/resourceList?pageType=jo2db&resourceType=journal&dbID=" +
                                  id
                                }>
                                ({this.props.t("jumper.common.listview")})
                              </Link>
                            </li>
                          );
                        }
                      }
                    }
                    if (ebookCount !== 0) {
                      journalURLTemp.push(
                        <li>
                          <div className="title">
                            {this.props.t("hyint.esource.collectebook")}:
                          </div>
                          <Link
                            href={
                              "/resourceList?pageType=jo2db&resourceType=ebook&dbID=" +
                              id
                            }>
                            ({this.props.t("jumper.common.listview")})
                          </Link>
                        </li>
                      );
                    }
                  }
                  return journalURLTemp;
                }
                if (
                  item.key !== "ebname" &&
                  item.key !== "en_ebname" &&
                  item.key !== "journal_url"
                ) {
                  if (item.key === "intro" || item.key === "en_intro") {
                    if (
                      (item.key === "intro" && language === "zh") ||
                      (item.key === "en_intro" && language === "en")
                    ) {
                      let intro = item.value || "";
                      intro = rr.htmlRemoveTag(intro);
                      let len = intro.length;
                      let isShowMore = len > maxIntroLen ? true : false;
                      if (len > maxIntroLen) {
                        intro = rr.cutIntro(intro, maxIntroLen);
                      }
                      if (intro !== "") {
                        outTemp.push(intro);
                        if (isShowMore) {
                          outTemp.push(
                            <>
                              <a
                                tabIndex="0"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleClick({ id });
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleClick({ id });
                                  }
                                }}>
                                {"(" + t("jumper.common.table.detail") + ")"}
                              </a>
                            </>
                          );
                        }
                      }
                    }
                  } else if (item.key === "url") {
                    let url = item.value;
                    if (url.length > 50) {
                      url = rr.cutIntro(url, 50);
                    }
                    outTemp.push(
                      <Link href={"/sendURLApiV3?dbid=" + id} target="_blank">
                        {url}
                      </Link>
                    );
                  } else if (item.key === "funds") {
                    item.value.split(",").map((tmp, k) => {
                      if (k !== 0) {
                        outTemp.push(",");
                      }
                      let name = "jumperrwd.funds.name." + tmp;
                      outTemp.push(this.props.t(name));
                      return "";
                    });
                  } else if (item.key === "note" || item.key === "en_note") {
                    if (
                      (item.key === "note" && language === "zh") ||
                      (item.key === "en_note" && language === "en")
                    ) {
                      let note = item.value;
                      /*
                        QueryBean Bean = new QueryBean();
                        Object[] Data = ResourceRelatedBean.getIsNote(rs.getString("c.id"),session.getAttribute("useUnitSN").toString(),session.getAttribute("Groupid_Val").toString());
                        boolean isNote = (Boolean) Data[1];	//取得是否顯示公告資訊
                      */
                      outTemp.push(ReactHtmlParser(note));
                    }
                  } else if (item.key === "platform") {
                    let platforms = item.value.split(",");
                    let platformString = "";
                    platforms.map((platform_id, k) => {
                      if (k > 0) {
                        platformString += ", "
                      }
                      platformString += t("jumperrwd.platform.name." + platform_id);
                      return "";
                    });
                    outTemp.push(platformString);
                  } else if (item.key === "browser") {
                    let browser_flag = false;
                    item.value.split(",").map((browser_id) => {
                      let browser_icon = this.props.t(
                        "jumperrwd.browser.icon." + browser_id
                      );
                      if (
                        browser_icon !==
                          "jumperrwd.browser.icon." + browser_id &&
                        browser_icon !== ""
                      ) {
                        outTemp.push(
                          <>
                            <img
                              src={
                                imagesPath +
                                this.props.t(
                                  "jumperrwd.browser.icon." + browser_id
                                )
                              }
                              title={this.props.t(
                                "jumperrwd.browser.name." + browser_id
                              )}
                              alt={this.props.t(
                                "jumperrwd.browser.name." + browser_id
                              )}
                            />
                          </>
                        );
                      } else {
                        if (browser_flag) {
                          outTemp.push(", ");
                        }
                        outTemp.push(
                          this.props.t("jumperrwd.browser.name." + browser_id)
                        );
                        browser_flag = true;
                      }
                      return "";
                    });
                  } else if (item.key === "eb_basic_url") {
                    if (urlData !== undefined && urlData !== null && urlData.length !== 0) {
                      urlData.map((urld, k) => {
                        let showname =
                          urld.showName ||
                          "(" + t("jumperrwd.common.noName") + ")";
                        let attachpath = urld.url || "";
                        let openwin = urld.openWin || "0";
                        if (k !== 0) {
                          outTemp.push("、");
                        }
                        if (openwin === "1") {
                          outTemp.push(
                            <Link href={attachpath}>{showname}</Link>
                          );
                        } else {
                          outTemp.push(
                            <>
                              <Link href={attachpath} target="_blank">
                                {showname}
                              </Link>
                            </>
                          );
                        }
                        return "";
                      });
                    }
                  } else if (item.key === "ebattach") {
                    if (attachData && attachData.length !== 0) {
                      attachData.map((attachd, k) => {
                        let showName =
                          attachd.showName || t("jumperrwd.common.file");
                        let attachPath = attachd.attachPath || "";
                        let fileTypePhoto = rr.getFileTypePhoto(attachPath);

                        if (k !== 0) {
                          outTemp.push("、");
                        }

                        let ebattachTemp = [];
                        if (fileTypePhoto !== "") {
                          ebattachTemp.push(
                            <>
                              &nbsp;
                              <img src={fileTypePhoto} alt="檔案類型" border="0" />
                            </>
                          );
                        }
                        outTemp.push(
                          <>
                            <Link href={"/file/downloadFile/" + attachPath}>
                              {showName}
                              {ebattachTemp}
                            </Link>
                          </>
                        );
                        return "";
                      });
                    }
                  } else if (item.key === "language") {
                    outTemp.push(
                      this.props.t("jumperrwd.language.name." + item.value)
                    );
                  } else if (item.key === "property") {
                    outTemp.push(
                      this.props.t("jumperrwd.property.name." + item.value)
                    );
                  } else if (item.key === "source") {
                    if (
                      this.props.t("jumperrwd.source.name." + item.value) ===
                      "jumperrwd.source.name." + item.value
                    ) {
                      outTemp.push(item.value);
                    } else {
                      outTemp.push(
                        this.props.t("jumperrwd.source.name." + item.value)
                      );
                    }
                  } else if (item.key === "connrange") {
                    outTemp.push(
                      this.props.t("jumperrwd.connrange.name." + item.value)
                    );
                  } else if (item.key === "cooperation") {
                    outTemp.push(
                      this.props.t("jumperrwd.cooperation.name." + item.value)
                    );
                  } else if (item.key === "publisher") {
                    outTemp.push(
                      this.props.t("jumperrwd.publisher.name." + item.value)
                    );
                  } else if (item.key === "ezproxy") {
                    outTemp.push(
                      this.props.t("jumperrwd.ezproxy." + item.value)
                    );
                  } else if (item.key !== "id") {
                    outTemp.push(item.value);
                  }
                }
                if (outTemp.length > 0) {
                  return (
                    <li>
                      <div className="title">
                        {t("jumperrwd.eb_basic_extension.name." + item.key)}：
                      </div>
                      <div>{outTemp}</div>
                    </li>
                  );
                }
                return "";
              })}
            </ul>
          </div>
        </div>
      </>
    );
  }
}

DBDisplayComp.propTypes = {
  /**
   * The layout define display config is used to define layout.
   * The datasoure is from LayoutReturnResult.display.
   */
  displayConfig: PropTypes.array.isRequired,

  /** td content */
  data: PropTypes.array,

  /** layout define's func, record link or button behavior. */
  functionConfigList: PropTypes.array,

  /** layout define's func_right, record link or button behavior. */
  functionRightConfigList: PropTypes.array,

  /** layout define's left_right, record link or button behavior. */
  functionLeftConfigList: PropTypes.array,

  /** layout define's detail */
  detailList: PropTypes.object,

  /** button events */
  buttonEvent: PropTypes.func,

  /**
   * batch config
   */
  batchConfig: PropTypes.array,

  /**
   * serialNo
   */
  serialNo: PropTypes.number,

  /**
   * checked the row or not;
   */
  checked: PropTypes.bool,

  /**
   * row style className
   */
  rowStyle: PropTypes.string,
};

DBDisplayComp.defaultProps = {
  buttonEvent: () => {},
  functionConfigList: [],
  functionRightConfigList: [],
  functionLeftConfigList: [],
  detailList: [],
  batchConfig: [],
  serialNo: -1,
  checked: false,
  rowStyle: "",
};

export default DBDisplayComp;
